import React from 'react';
import { Flame } from 'lucide-react';
import '../platform/streaks.css';

export const DailyStreakStrip = ({ streak, prefix = 'account' }) => {
  if (!streak) return null;
  const dayLabel = n => n === 1 ? 'day' : 'days';
  let note = 'Finish all three Daily cuts to start a streak.';
  if (streak.completed_today) note = 'Come back tomorrow to keep it going.';
  else if (streak.current > 0) note = `Complete today’s Slice before 00:00 UTC to make it ${streak.current + 1}.`;
  return <section className="ps-identity ps-streak-strip" aria-labelledby={`${prefix}-daily-streak-title`} data-testid={`${prefix}-daily-streak-strip`}>
    <div className="ps-streak-main"><div className="ps-streak-title"><Flame size={22} aria-hidden="true"/><h2 id={`${prefix}-daily-streak-title`} data-testid={`${prefix}-daily-streak-heading`}>Daily streaks</h2></div>
      <dl className="ps-streak-values"><div><dt data-testid={`${prefix}-daily-streak-current-label`}>Current Daily streak</dt><dd data-testid={`${prefix}-daily-streak-current-value`}>{streak.current} <small>{dayLabel(streak.current)}</small></dd></div><div><dt data-testid={`${prefix}-daily-streak-best-label`}>Best Daily streak</dt><dd data-testid={`${prefix}-daily-streak-best-value`}>{streak.best} <small>{dayLabel(streak.best)}</small></dd></div></dl>
    </div>
    <p className="ps-streak-note" data-testid={`${prefix}-daily-streak-note`}>{note} Consecutive completed UTC days count. Your historical best stays saved.</p>
  </section>;
};
